import PropTypes from 'prop-types';

import latlng from './latlng';

export default PropTypes.arrayOf(latlng);